// INSTALLED 
import {
  setDevicesRedux,
  storeDeviceRedux,
  setSurveysRedux,
  storeSurveyRedux,
  setAssignmentsRedux,
  storeAssignmentRedux,
  setQualificationsRedux,
  setUsersSelectListRedux,
  setStatsRedux,
  setMonthlyStatsRedux,
  setMonthlyMetricsRedux,
  setHasDiscrepancieRedux,
  setCompletionPercentageRedux,
  setNpsRedux,
  setCsatRedux,
  setCesRedux,
  setDiscrepancyMessageRedux,
  setUsersListRatingsDevicesRedux,
  setAlertRiskLevelTriggerLogRedux,
  setRulesAndAlertsListRedux,
  setRulesAndAlertsRedux,
  setAvailableUsersForAlertsRedux,
  setResumenRedux,
  setAreasRatingsListRedux,
  setAreasListSelectListRedux,
  setAreaRatingRedux,
  setGoogleBusinessDataRedux,
  setPlantillasRedux,
  setPlantillasCategoriesRedux,
  setRecurringFindingsRedux,
  setAreasQualifications,
  setQualificationsStats,
  setFollowConfigListRedux,
  setScoreThresholdRedux,
  setDinamicTextsListRedux,
  addOrUpdateReviewLinkRedux,
  deleteReviewLinkRedux,
  setWhatsappTemplatesRedux,
  addOrUpdateWhatsappTemplateRedux,
  deleteWhatsappTemplateRedux,
  setReviewLinksRedux,
  setGoogleBussinessesRedux
} from './RatingsSlice';
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  activeRatingsDeviceService,
  createRatingsDeviceService,
  desactiveRatingsDeviceService,
  getRatingsDeviceDetailService,
  getRatingsDevicesByPaginateService,
  getRatingsDevicesBySearchService,
  getRatingsDevicesService,
  updateRatingsDeviceService,
  getRatingsSurveysService,
  getRatingsSurveysByPaginateService,
  getRatingsSurveysBySearchService,
  createRatingsSurveyService,
  updateRatingsSurveyService,
  deleteRatingsSurveyService,
  activeRatingsSurveyService,
  getRatingsSurveyDetailService,
  getRatingsAssignmentsService,
  getRatingsAssignmentsByPaginateService,
  getRatingsAssignmentsBySearchService,
  createRatingsAssignmentService,
  updateRatingsAssignmentService,
  deleteRatingsAssignmentService,
  activeRatingsAssignmentService,
  getQualificationsService,
  getQualificationsByPaginateService,
  deleteQualificationService,
  restoreQualificationService,
  getRatingsAssignmentDetailService,
  getAvailableUsersRatingsService,
  getAvailableConfigsRatingsService,
  getAlertRiskLevelTriggerLogService,
  postAlertRiskLevelTriggerLogFollowUpService,
  updateAlertRiskLevelTriggerLogService,
  getRulesAndAlertsPaginationService,
  getRulesAndAlertsBySearchService,
  createRulesAndAlertService,
  updateRulesAndAlertService,
  deleteRulesAndAlertService,
  restoreRulesAndAlertService,
  getRulesAndAlertDetailService,
  getAvailableUsersForAlertsService,
  getRatingsResumenService,
  getGoogleBusinessStatusService,
  postGoogleCallbackService,
  deleteGoogleBusinessService,
  getGoogleBusinessReviewsStatisticsService,
  getGoogleBusinessResenasService,
  getGoogleBusinessResumenService,
  getPlantillasCategoriesService,
  getPlantillasRespuestasService,
  getPlantillasRespuestasByPaginateService,
  getPlantillasRespuestasBySearchService,
  createPlantillaRespuestaService,
  updatePlantillaRespuestaService,
  postGenerateAiResponseReviewService,
  desactivePlantillaRespuestaService,
  activePlantillaRespuestaService,
  getRecurringFindingsService,
  getFollowConfigService,
  createFollowConfigService,
  updateFollowConfigService,
  deleteFollowConfigService,
  restoreFollowConfigService,
  getDinamicTextsService,
  createDinamicTextService,
  updateDinamicTextService,
  deleteDinamicTextService,
  restoreDinamicTextService,
  replyGoogleBusinessReviewService,
  getGoogleBussinessesService
} from '../../services/ratings.service';
import { 
    getAreasRatingsService,
    getAreasRatingsBySearchService,
    createAreasRatingService,
    updateAreasRatingService,
    deleteAreasRatingService,
    restoreAreasRatingService,
    getAreasRatingsPaginatedService,
    getAreasRatingDetailService
} from '../../services/areasRatings.service';
import {
  getReviewLinksService,
  createReviewLinkService,
  updateReviewLinkService,
  deleteReviewLinkService
} from '../../services/reviewLinks.service';
import {
  getShareTemplatesService,
  createShareTemplateService,
  updateShareTemplateService,
  deleteShareTemplateService
} from '../../services/shareTemplates.service';
import { setAvailableConfigsRedux } from './RatingsSlice';
import { setLinksShareTemplatesForSelect } from '../links_encuestas';
import { setTemplatesForSelect } from '../shift_templates';





export const getGoogleBussinessesStore = (): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await getGoogleBussinessesService();


      if (result.ok) {
        await dispatch(setGoogleBussinessesRedux(result.data));
      }

      await dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('getGoogleBussinessesStore thunk ', error);
      await dispatch(unCheckingPreload());
    }
  }
}





export const getDevicesStore = (status?: number): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await getRatingsDevicesService(status);


      if (result.ok) {

        await dispatch(setDevicesRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('getDevicesStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}


export const getDevicesByPagination = (page: number, status?: number): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await getRatingsDevicesByPaginateService(page, status);


      if (result.ok) {
        await dispatch(setDevicesRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('getDevicesByPagination thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getDevicesBySearch = (param: string, status?: number): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await getRatingsDevicesBySearchService(param, status);


      if (result.ok) {
        await dispatch(setDevicesRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('getDevicesBySearch thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}


export const storeCreateDevice = (device: any, percentage: any): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await createRatingsDeviceService(device, percentage);

      if (result.ok) {
        await dispatch(setDevicesRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('storeCreateDevice thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}




export const storeDesactiveDevice = (deviceId: string, search: string = '', page: number = 1, status?: number): any => {


  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await desactiveRatingsDeviceService(deviceId, search, page, status);


      dispatch(unCheckingPreload());

      if (result.ok) {
        if (search) {
           await dispatch(getDevicesBySearch(search, status));
        } else {
           await dispatch(getDevicesByPagination(page, status));
        }
      }

      return result;
    } catch (error) {
      console.log('storeDesactiveDevice thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}


export const storeActiveDevice = (deviceId: string, search: string = '', page: number = 1, status?: number): any => {


  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await activeRatingsDeviceService(deviceId, search, page, status);


      dispatch(unCheckingPreload());

      if (result.ok) {
        if (search) {
           await dispatch(getDevicesBySearch(search, status));
        } else {
           await dispatch(getDevicesByPagination(page, status));
        }
      }

      return result;
    } catch (error) {
      console.log('storeActiveDevice thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}


export const storeDetailDevice = (deviceId: string): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await getRatingsDeviceDetailService(deviceId);


      if (result.ok) {

        await dispatch(storeDeviceRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('storeDetailDevice thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}


export const storeUpdateDevice = (device: any): any => {

  return async (dispatch: any) => {

    try {
      await dispatch(checkingPreload());

      const result = await updateRatingsDeviceService(device);


      if (result.ok) {

        await dispatch(setDevicesRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('storeUpdateDevice thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}


export const getSurveysStore = (status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsSurveysService(status);
      if (result.ok) {
        await dispatch(setSurveysRedux(result.data));
        await dispatch(setAreasListSelectListRedux(result.data.areasRatings));
        await dispatch(setDinamicTextsListRedux(result.data.dinamicTexts));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getSurveysStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getSurveysByPagination = (page: number, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsSurveysByPaginateService(page, status);
      if (result.ok) {
        await dispatch(setSurveysRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getSurveysByPagination thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getSurveysBySearch = (param: string, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsSurveysBySearchService(param, status);
      if (result.ok) {
        await dispatch(setSurveysRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getSurveysBySearch thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeCreateSurvey = (survey: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());

      const payload = {
        name: survey.name,
        description: survey.description,
        areas_rating_id: survey.areas_rating_id || null,
        type: survey.type || null,
        questions: survey.questions.map((q: any) => ({
          questionText: q.questionText,
          order: q.order,
          isRequired: q.isRequired,
          isOpenQuestion: q.isOpenQuestion ?? false,
          openQuestionType: q.openQuestionType || 'text',
          imgName: (q.imgName && typeof q.imgName === 'object') ? q.imgName.imgName : (q.imgName || null),
          metricType: q.metricType || null
        })),
        reviewLinks: survey.reviewLinks || []
      };

      const result = await createRatingsSurveyService(payload);
      if (result.ok) {
        // Re-fetch or update list
        const updatedList = await getRatingsSurveysService();
        if (updatedList.ok) await dispatch(setSurveysRedux(updatedList.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeCreateSurvey thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeUpdateSurvey = (survey: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());

      const payload = {
        id: survey.id,
        name: survey.name,
        description: survey.description,
        areas_rating_id: survey.areas_rating_id || null,
        type: survey.type || null,
        questions: survey.questions.map((q: any) => ({
          ...(q.id && { id: q.id }),
          questionText: q.questionText,
          order: q.order,
          isRequired: q.isRequired,
          isOpenQuestion: q.isOpenQuestion ?? false,
          openQuestionType: q.openQuestionType || 'text',
          imgName: (q.imgName && typeof q.imgName === 'object') ? q.imgName.imgName : (q.imgName || null),
          metricType: q.metricType || null
        })),
        reviewLinks: survey.reviewLinks || []
      };

      const result = await updateRatingsSurveyService(payload);
      if (result.ok) {
        const updatedList = await getRatingsSurveysService();
        if (updatedList.ok) await dispatch(setSurveysRedux(updatedList.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeUpdateSurvey thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeDeleteSurvey = (surveyId: string, search: string = '', page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteRatingsSurveyService(surveyId, search, page, status);
      if (result.ok) {
        await dispatch(setSurveysRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeDeleteSurvey thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeActiveSurvey = (surveyId: string, search: string = '', page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await activeRatingsSurveyService(surveyId, search, page, status);
      if (result.ok) {
        await dispatch(setSurveysRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeActiveSurvey thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeDetailSurvey = (surveyId: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsSurveyDetailService(surveyId);
      if (result.ok) {
        await dispatch(storeSurveyRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeDetailSurvey thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getAssignmentsStore = (status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsAssignmentsService(status);
      if (result.ok) {
        await dispatch(setAssignmentsRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getAssignmentsStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getAssignmentsByPagination = (page: number, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsAssignmentsByPaginateService(page, status);
      if (result && (result.ok || result.code === 200)) {
        await dispatch(setAssignmentsRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getAssignmentsByPagination thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getAssignmentsBySearch = (param: string, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsAssignmentsBySearchService(param, status);
      if (result.ok ) {
        await dispatch(setAssignmentsRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getAssignmentsBySearch thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeCreateAssignment = (assignment: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());

      const payload = {
        deviceManagementId: assignment.deviceManagementId,
        surveyId: assignment.surveyId,
      };

      const result = await createRatingsAssignmentService(payload);
      if (result.ok) {
        const updatedList = await getRatingsAssignmentsService();
        if (updatedList.ok) await dispatch(setAssignmentsRedux(updatedList.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeCreateAssignment thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeUpdateAssignment = (assignment: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());

      const payload = {
        id: assignment.id,
        deviceManagementId: assignment.deviceManagementId,
        surveyId: assignment.surveyId,
      };

      const result = await updateRatingsAssignmentService(payload);
      if (result.ok) {
        const updatedList = await getRatingsAssignmentsService();
        if (updatedList.ok) await dispatch(setAssignmentsRedux(updatedList.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeUpdateAssignment thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeDeleteAssignment = (assignmentId: string, search: string = '', page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteRatingsAssignmentService(assignmentId, search, page, status);
      
      if (result.ok) { 
        await dispatch(setAssignmentsRedux(result.data));
      }

      dispatch(unCheckingPreload());

      return result;
    } catch (error) {
      console.log('storeDeleteAssignment thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeActiveAssignment = (assignmentId: string, search: string = '', page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await activeRatingsAssignmentService(assignmentId, search, page, status);
      if (result.ok) {
        await dispatch(setAssignmentsRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeActiveAssignment thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeDetailAssignment = (assignmentId: string, mode?: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsAssignmentDetailService(assignmentId, mode);
      if (result.ok) {
        await dispatch(storeAssignmentRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeDetailAssignment thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}



export const getQualificationsStore = (userId?: string, fromDate?: string, toDate?: string, reportedEvents?: string, status?: number, areaId?: string, locationId?: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getQualificationsService(userId, fromDate, toDate, reportedEvents, status, areaId, locationId);
      if (result.ok) {
        await dispatch(setQualificationsRedux(result.data));
        await dispatch(setUsersSelectListRedux(result.data.users));
        await dispatch(setStatsRedux(result.data.stats));
        await dispatch(setMonthlyStatsRedux(result.data.monthlyStats));
        await dispatch(setMonthlyMetricsRedux(result.data.monthlyMetrics || []));
        await dispatch(setHasDiscrepancieRedux(result.data.hasDiscrepancie));
        await dispatch(setCompletionPercentageRedux(result.data.completionPercentage));
        await dispatch(setNpsRedux(result.data.nps || { score: 0, total: 0, promoters: 0, passives: 0, detractors: 0 }));
        await dispatch(setCsatRedux(result.data.csat || { score: 0, total: 0, positive: 0, negative: 0 }));
        await dispatch(setCesRedux(result.data.ces || { score: 0, total: 0, sum: 0 }));
        await dispatch(setDiscrepancyMessageRedux(result.data.discrepancyMessage));
        await dispatch(setAreasQualifications(result.data.areas));
        await dispatch(setGoogleBussinessesRedux(result.data.business));
      }

      dispatch(unCheckingPreload());
      return result;
      
    } catch (error) {
      console.log('getQualificationsStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getQualificationsByPagination = (page: number, filters: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getQualificationsByPaginateService(page, filters);
      if (result.ok) {
        await dispatch(setQualificationsRedux(result.data));
        await dispatch(setUsersSelectListRedux(result.data.users));
        await dispatch(setStatsRedux(result.data.stats));
        await dispatch(setMonthlyStatsRedux(result.data.monthlyStats));
        await dispatch(setMonthlyMetricsRedux(result.data.monthlyMetrics || []));
        await dispatch(setHasDiscrepancieRedux(result.data.hasDiscrepancie));
        await dispatch(setCompletionPercentageRedux(result.data.completionPercentage));
        await dispatch(setNpsRedux(result.data.nps || { score: 0, total: 0, promoters: 0, passives: 0, detractors: 0 }));
        await dispatch(setCsatRedux(result.data.csat || { score: 0, total: 0, positive: 0, negative: 0 }));
        await dispatch(setCesRedux(result.data.ces || { score: 0, total: 0, sum: 0 }));
        await dispatch(setDiscrepancyMessageRedux(result.data.discrepancyMessage));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getQualificationsByPagination thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeDeleteQualification = (qualificationId: string, filters: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteQualificationService(qualificationId, filters);
      dispatch(unCheckingPreload());
      if (result.ok) {
        await dispatch(getQualificationsStore(filters.userId, filters.fromDate, filters.toDate, filters.reportedEvents, filters.status, filters.areaId));
      }
      return result;
    } catch (error) {
      console.log('storeDeleteQualification thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeRestoreQualification = (qualificationId: string, filters: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await restoreQualificationService(qualificationId, filters);
      dispatch(unCheckingPreload());
      if (result.ok) {
        await dispatch(getQualificationsStore(filters.userId, filters.fromDate, filters.toDate, filters.reportedEvents, filters.status, filters.areaId));
      }
      return result;
    } catch (error) {
      console.log('storeRestoreQualification thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}
export const getAvailableUsersRatingsStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getAvailableUsersRatingsService();
      if (result.ok) {
        await dispatch(setUsersListRatingsDevicesRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getAvailableUsersRatingsStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getAvailableConfigsRatingsStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getAvailableConfigsRatingsService();
      if (result.ok) {
        await dispatch(setAvailableConfigsRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getAvailableConfigsRatingsStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getAlertRiskLevelTriggerLogStore = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getAlertRiskLevelTriggerLogService(id);
      if (result.ok) {
        await dispatch(setAlertRiskLevelTriggerLogRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getAlertRiskLevelTriggerLogStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeAlertRiskLevelTriggerLogFollowUp = (id: string, payload: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await postAlertRiskLevelTriggerLogFollowUpService(id, payload);
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeAlertRiskLevelTriggerLogFollowUp thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const updateAlertRiskLevelTriggerLogStore = (id: string, payload: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await updateAlertRiskLevelTriggerLogService(id, payload);
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('updateAlertRiskLevelTriggerLogStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

// =====================================================================
// REGLAS Y ALERTAS (RULES AND ALERTS)
// =====================================================================

export const getRulesAndAlertsPaginationStore = (page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRulesAndAlertsPaginationService(page, status);
      if (result && result.ok) {
        await dispatch(setRulesAndAlertsListRedux(result.data));
        if (result.data.users) await dispatch(setAvailableUsersForAlertsRedux(result.data.users));
        await dispatch(setScoreThresholdRedux(result.data.scoreThreshold));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getRulesAndAlertsPaginationStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getRulesAndAlertsBySearchStore = (param: string, page?: number, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRulesAndAlertsBySearchService(param, status);
      if (result && result.ok) {
        await dispatch(setRulesAndAlertsListRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getRulesAndAlertsBySearchStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getRulesAndAlertDetailStore = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRulesAndAlertDetailService(id);
      if (result && result.ok) {
        await dispatch(setRulesAndAlertsRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getRulesAndAlertDetailStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeRulesAndAlert = (payload: any, isEdit: boolean = false, id: string = ''): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      let result;
      if (isEdit) {
        result = await updateRulesAndAlertService(id, payload);
      } else {
        result = await createRulesAndAlertService(payload);
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeRulesAndAlert thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const deleteRulesAndAlertStore = (id: string, search: string = '', page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteRulesAndAlertService(id, search, page, status);
      if (result && result.ok) {
        await dispatch(setRulesAndAlertsListRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('deleteRulesAndAlertStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const restoreRulesAndAlertStore = (id: string, search: string = '', page: number = 1, status?: number): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await restoreRulesAndAlertService(id, search, page, status);
      if (result && result.ok) {
        await dispatch(setRulesAndAlertsListRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('restoreRulesAndAlertStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getAvailableUsersForAlertsStore = (search: string = ''): any => {
  return async (dispatch: any) => {
    try {
      // Usar en un autocomplete
      const result = await getAvailableUsersForAlertsService(`?search=${search}`);
      if (result && result.ok) {
        await dispatch(setAvailableUsersForAlertsRedux(result.data.data || result.data));
      }
      return result;
    } catch (error) {
      console.log('getAvailableUsersForAlertsStore thunk ', error);
    }
  }
}

export const getRatingsResumenStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getRatingsResumenService();
      if (result && result.ok) {
        await dispatch(setResumenRedux(result.data));
        
        await dispatch(setQualificationsStats(result.data.stats));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getRatingsResumenStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getGoogleBusinessStatusStore = (): any => {
  return async (dispatch: any) => {
    try {

      await dispatch(checkingPreload());
      const result = await getGoogleBusinessStatusService();
      if (result.ok) {
        await dispatch(setGoogleBusinessDataRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getGoogleBusinessStatusStore thunk ', error);
    }
  }
}

export const postGoogleCallbackStore = (code: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await postGoogleCallbackService(code);
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('postGoogleCallbackStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const deleteGoogleBusinessStore = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteGoogleBusinessService(id);
      if (result?.ok) {
        await dispatch(setGoogleBusinessDataRedux(null));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('deleteGoogleBusinessStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getGoogleBusinessReviewsStatisticsStore = (locationId?: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getGoogleBusinessReviewsStatisticsService(locationId);
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getGoogleBusinessReviewsStatisticsStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getGoogleBusinessResenasStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getGoogleBusinessResenasService();
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getGoogleBusinessResenasStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getGoogleBusinessResumenStore = (locationId?: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getGoogleBusinessResumenService(locationId);

      if (result.ok) {
        await dispatch(setGoogleBussinessesRedux(result.data.business));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getGoogleBusinessResumenStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeReplyGoogleBusinessReview = (reviewId: string, comment: string) => {
  return async (dispatch: any, getState: any) => {
    dispatch(checkingPreload());
    try {
      const response = await replyGoogleBusinessReviewService(reviewId, comment);
      if (response && response.ok) {
        dispatch(getGoogleBusinessResumenStore());
      }
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(unCheckingPreload());
    }
  }
}

export const generateAiResponseReviewStore = (payload: any) => {
  return async (dispatch: any, getState: any) => {
    dispatch(checkingPreload());
    try {
      const response = await postGenerateAiResponseReviewService(payload);
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(unCheckingPreload());
    }
  }
}


// =====================================================================
// AREAS RATINGS 
// =====================================================================

export const getAreasCalificacionesStore = (status?: number): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getAreasRatingsService(status);
        if (result && result.ok) {
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const getAreasRatingsBySearch = (param: string, status?: number): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getAreasRatingsBySearchService(param, status);
        if (result && result.ok) {
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const getAreasRatingsByPagination = (page: number = 0, status?: number): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getAreasRatingsPaginatedService(page, status);
        if (result && result.ok) {
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const getAreaRatingDetailStore = (id: string): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getAreasRatingDetailService(id);
        if (result && result.ok) {
            await dispatch(setAreaRatingRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeCreateAreasRating = (payload: any): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await createAreasRatingService(payload);
        if(result && result.ok){
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeUpdateAreasRating = (id: string, payload: any): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await updateAreasRatingService(id, payload);
        if(result && result.ok){
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeDeleteAreasRating = (id: string, value: string = '', page: number = 1, status?: number): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await deleteAreasRatingService(id, value, page, status);
        if (result && result.ok) {
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeRestoreAreasRating = (id: string, value: string = '', page: number = 1, status?: number): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await restoreAreasRatingService(id, value, page, status);
        if (result && result.ok) {
            await dispatch(setAreasRatingsListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

// --- PLANTILLAS DE RESPUESTAS ---

export const getPlantillasCategoriesStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getPlantillasCategoriesService();
      if (result.ok) {
        await dispatch(setPlantillasCategoriesRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getPlantillasCategoriesStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const getPlantillasStore = (locationId?: string): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getPlantillasRespuestasService(locationId);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data)); 
            
            await dispatch(setTemplatesForSelect(result.data.templates));

            await dispatch(setGoogleBussinessesRedux(result.data.business));
        }
        dispatch(unCheckingPreload()); 
        return result;
    }
}

export const getPlantillasByPagination = (page: number, locationId?: string): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getPlantillasRespuestasByPaginateService(page, locationId);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const getPlantillasBySearch = (param: string, page: number = 1, locationId?: string): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getPlantillasRespuestasBySearchService(param, page, locationId);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeCreatePlantilla = (data: any): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await createPlantillaRespuestaService(data);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data));
            await dispatch(setTemplatesForSelect(result.data.templates));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeUpdatePlantilla = (data: any): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await updatePlantillaRespuestaService(data);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data));
            await dispatch(setTemplatesForSelect(result.data.templates));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeDeletePlantilla = (id: string, value: string = '', page: number = 1): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await desactivePlantillaRespuestaService(id, value, page);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const storeRestorePlantilla = (id: string, value: string = '', page: number = 1): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await activePlantillaRespuestaService(id, value, page);
        if (result && result.ok) {
            await dispatch(setPlantillasRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const getRecurringFindingsStore = (): any => {
    return async (dispatch: any) => {
        try {
            await dispatch(checkingPreload());
            const result = await getRecurringFindingsService();
            if (result.ok) {
                await dispatch(setRecurringFindingsRedux(result.data));
            }
            dispatch(unCheckingPreload());
            return result;
        } catch (error) {
            console.log('getRecurringFindingsStore thunk ', error);
            dispatch(unCheckingPreload());
        }
    }
}

export const getFollowConfigStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getFollowConfigService();
      if (result && result.ok) {
        await dispatch(setFollowConfigListRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getFollowConfigStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeCreateFollowConfig = (payload: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await createFollowConfigService(payload);
      if (result && result.ok) {
        await dispatch(getRulesAndAlertsPaginationStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeCreateFollowConfig thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeUpdateFollowConfig = (id: string, payload: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await updateFollowConfigService(id, payload);
      if (result && result.ok) {
        await dispatch(getRulesAndAlertsPaginationStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeUpdateFollowConfig thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeDeleteFollowConfig = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteFollowConfigService(id);
      if (result && result.ok) {
        await dispatch(getRulesAndAlertsPaginationStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeDeleteFollowConfig thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const storeRestoreFollowConfig = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await restoreFollowConfigService(id);
      if (result && result.ok) {
        await dispatch(getRulesAndAlertsPaginationStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeRestoreFollowConfig thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

// --- Dinamic Qualification Texts Thunks ---

export const getDinamicTextsStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getDinamicTextsService();
      if (result && result.ok) {
        const formatted = result.data.map((item: any) => ({
          ...item,
          label: item.name,
          value: item.id
        }));
        await dispatch(setDinamicTextsListRedux(formatted));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getDinamicTextsStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const createDinamicTextStore = (data: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await createDinamicTextService(data);
      if (result && result.ok) {
        await dispatch(getDinamicTextsStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('createDinamicTextStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const updateDinamicTextStore = (id: string, data: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await updateDinamicTextService(id, data);
      if (result && result.ok) {
        await dispatch(getDinamicTextsStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('updateDinamicTextStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const deleteDinamicTextStore = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteDinamicTextService(id);
      if (result && result.ok) {
        await dispatch(getDinamicTextsStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('deleteDinamicTextStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

export const restoreDinamicTextStore = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await restoreDinamicTextService(id);
      if (result && result.ok) {
        await dispatch(getDinamicTextsStore());
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('restoreDinamicTextStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
}

// ==========================================
// REVIEW LINKS
// ==========================================

export const getReviewLinksStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getReviewLinksService();
      if (result.ok) {
        await dispatch(setReviewLinksRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getReviewLinksStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

export const storeCreateReviewLink = (data: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await createReviewLinkService(data);
      if (result.ok) {
        await dispatch(addOrUpdateReviewLinkRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeCreateReviewLink thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

export const storeUpdateReviewLink = (id: string, data: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await updateReviewLinkService(id, data);
      if (result.ok) {
        await dispatch(addOrUpdateReviewLinkRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeUpdateReviewLink thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

export const storeDeleteReviewLink = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteReviewLinkService(id);
      if (result.ok) {
        await dispatch(deleteReviewLinkRedux(id));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeDeleteReviewLink thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

// ==========================================
// WHATSAPP (SHARE) TEMPLATES
// ==========================================

export const getWhatsappTemplatesStore = (): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await getShareTemplatesService();
      if (result.ok) {
        await dispatch(setWhatsappTemplatesRedux(result.data));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('getWhatsappTemplatesStore thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

export const storeCreateWhatsappTemplate = (data: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await createShareTemplateService(data);

    
      if (result.ok) {
        await dispatch(addOrUpdateWhatsappTemplateRedux(result.data.items));
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
      }  
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeCreateWhatsappTemplate thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

export const storeUpdateWhatsappTemplate = (id: string, data: any): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await updateShareTemplateService(id, data);
      if (result.ok) {
        await dispatch(addOrUpdateWhatsappTemplateRedux(result.data.items));
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeUpdateWhatsappTemplate thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

export const storeDeleteWhatsappTemplate = (id: string): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      const result = await deleteShareTemplateService(id);
      if (result.ok) {
        await dispatch(deleteWhatsappTemplateRedux(id));
        await dispatch(setLinksShareTemplatesForSelect(result.data.shareTemplates));
      }
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      console.log('storeDeleteWhatsappTemplate thunk ', error);
      dispatch(unCheckingPreload());
    }
  }
};

